import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-24 px-4 bg-white" data-id="element-11">
      <div className="max-w-5xl mx-auto" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-serif text-[#2D2A26] mb-4" data-id="element-14">
            Para quién es (y para quién no)
          </h2>
          <p className="text-[#8B7355] italic" data-id="element-15">
            Honestidad radical para no hacerte perder tiempo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-16">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#FBF7F4] p-8 md:p-10 rounded-lg border-t-4 border-[#C4A08A]" data-id="element-17">
            <h3 className="text-2xl font-serif text-[#2D2A26] mb-6 flex items-center gap-3" data-id="element-18">
              <CheckCircle2 className="text-[#C4A08A]" data-id="element-19" />
              Esto es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-20">
              {['Sientes que tu piel cambió y ahora es más reactiva', 'Te salen brotes/rojez con estrés, calor o falta de sueño', 'Estás cansada de “prueba y error”', 'Quieres una rutina mínima, realista, sostenida'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#2D2A26]/80" data-id="element-21">
                  <span className="block w-1.5 h-1.5 bg-[#C4A08A] rounded-full mt-2.5 flex-shrink-0" data-id="element-22" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-50 p-8 md:p-10 rounded-lg border-t-4 border-gray-300" data-id="element-23">
            <h3 className="text-2xl font-serif text-gray-600 mb-6 flex items-center gap-3" data-id="element-24">
              <XCircle className="text-gray-400" data-id="element-25" />
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-26">
              {['Buscas promesas médicas o “cura” garantizada', 'Estás en un tratamiento dermatológico y no quieres coordinar cambios', 'Quieres rutinas maximalistas y probar 10 cosas a la vez'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-500" data-id="element-27">
                  <span className="block w-1.5 h-1.5 bg-gray-300 rounded-full mt-2.5 flex-shrink-0" data-id="element-28" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}